module.exports = __webpack_public_path__ + "assets/jiaoshijie.c2def9e8.svg";